import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, OnDestroy {
  displayMenuItems : boolean; 

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.displayMenuItems = (Array.isArray(this.userService.getClaims().role)) ? this.userService.getClaims().role.includes('AEE_Admin') : (typeof this.userService.getClaims().role === 'string' && this.userService.getClaims().role === 'AEE_Admin');
  }

  ngOnDestroy(): void {}
}
